(()=>{
  'use strict';
  if(window.__rbCartDiscountBound) return;
  window.__rbCartDiscountBound=true;

  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-cart-discount-form]');
    if(!form) return;
    event.preventDefault();

    const input=form.querySelector('[name="discount_code"]');
    const code=input?.value.trim();
    if(!code){
      input?.focus();
      return;
    }

    const button=form.querySelector('button[type="submit"]');
    const initialLabel=button?.textContent;
    if(button){
      button.disabled=true;
      button.textContent='Application…';
    }

    const inDrawer=Boolean(form.closest('#offcanvas-cart'));
    try{
      const root=window.Shopify?.routes?.root||'/';
      const redirect=`${window.location.pathname}${window.location.search}`;
      const response=await fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`,{
        credentials:'same-origin',
        redirect:'follow'
      });
      if(!response.ok||typeof window.updateCartContents!=='function'){
        throw new Error('Discount refresh unavailable');
      }

      await window.updateCartContents(response);
      const scope=inDrawer?document.querySelector('#offcanvas-cart'):document.querySelector('#cart');
      const details=scope?.querySelector('[data-cart-discount]');
      const applied=scope?.querySelector('.rb-cart-discount-applied');
      if(details){
        const status=details.querySelector('[data-cart-discount-status]');
        if(applied){
          details.open=false;
        }else{
          details.open=true;
          if(status){
            status.textContent='Aucune remise n’a été appliquée. Vérifiez ce code.';
            status.hidden=false;
          }
        }
      }
    }catch(error){
      const details=form.closest('[data-cart-discount]');
      const status=details?.querySelector('[data-cart-discount-status]');
      if(status){
        status.textContent='Impossible d’enregistrer ce code pour le moment. Réessayez.';
        status.hidden=false;
      }
      if(button){
        button.disabled=false;
        button.textContent=initialLabel;
      }
    }
  });
})();
